import { t } from '@lingui/core/macro';
import { EmojiEmotionsOutlined } from '@mui/icons-material';
import { Box, Popover } from '@mui/material';
import type { Editor } from '@tiptap/react';
import { type FC, lazy, Suspense, useRef, useState } from 'react';
import { ToolbarButton } from './ToolbarButton';

const EmojiPicker = lazy(async () => {
  const [{ default: data }, mod] = await Promise.all([
    import('@emoji-mart/data'),
    import('@emoji-mart/react'),
  ]);
  const Picker = mod.default;
  return {
    default: ({ onSelect }: { onSelect: (emoji: string) => void }) => (
      <Picker data={data} onEmojiSelect={(e: { native: string }) => onSelect(e.native)} />
    ),
  };
});

type Props = {
  editor: Editor;
};

export const EmojiPickerButton: FC<Props> = ({ editor }) => {
  const anchorRef = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);

  const handleSelect = (emoji: string) => {
    editor.chain().focus().insertContent(emoji).run();
    setOpen(false);
  };

  return (
    <>
      <span ref={anchorRef}>
        <ToolbarButton
          label={t`Insérer un emoji`}
          icon={<EmojiEmotionsOutlined fontSize="small" />}
          onClick={() => setOpen(true)}
        />
      </span>
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Suspense fallback={<Box sx={{ p: 2 }}>{t`Chargement…`}</Box>}>
          <EmojiPicker onSelect={handleSelect} />
        </Suspense>
      </Popover>
    </>
  );
};
